import {
  DateTimeRange,
  IOrdersFilterStatus,
} from '../modules/orders-and-product-catalog/modules/orders/reducers/reducer';
import * as moment from 'moment';
import { CwcInputDateRange } from '@cmx-web-components/core';
import { OrderProduct, ProductOP } from '@cemex-core/cmx-api';

export const checkIfAllOrNoneIsSelected = (statuses: IOrdersFilterStatus[]) => {
  let allIsSelected = true;
  let noneIsSelected = true;

  statuses.map((status) => {
    if ((!allIsSelected && !noneIsSelected) || status.disabled) {
      // no point to check anymore
      return;
    }
    if (allIsSelected) {
      allIsSelected = status.selected;
    }
    if (noneIsSelected) {
      noneIsSelected = !status.selected;
    }
  });

  return [allIsSelected, noneIsSelected];
};

export const getDefaultOrderDateTimeRange = (monthsToDisplay = 3): DateTimeRange => {
  const dateTimeTo = moment();
  dateTimeTo.local();
  const dateTimeFrom = dateTimeTo.clone().subtract(monthsToDisplay, 'months');
  return {
    from: moment(dateTimeFrom.startOf('day')).toISOString(true),
    to: moment(dateTimeTo.endOf('day')).toISOString(true),
  };
};

export const convertDateToDateTime = (dateRange: CwcInputDateRange): DateTimeRange => {
  return {
    from: moment(dateRange.from).startOf('day').toISOString(true),
    to: moment(dateRange.to).endOf('day').toISOString(true),
  };
};

/**
 *
 * @deprecated Use filterConcreteProductsOrNoTValue instead
 */
export const filterConcreteProducts = (value: OrderProduct | ProductOP, index: number, array: any[]): boolean => {
  return value?.['concreteProductTypeCode'] === 'TECH';
};

export const filterConcreteProductsOrNoTValue = (
  value: OrderProduct | ProductOP,
  index: number,
  array: any[],
): boolean => {
  return !value?.['concreteProductTypeCode'] || value?.['concreteProductTypeCode'] !== 'EXTP';
};

export const filterConcreteExtraProducts = (value: OrderProduct | ProductOP, index: number, array: any[]): boolean => {
  return value?.['concreteProductTypeCode'] === 'EXTP';
};
